import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "max"]
const _hoisted_2 = ["value", "max"]

import { ref } from 'vue';

const cssClass = 'videoplayer';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoProgress',
  props: {
    progress: {},
    duration: {}
  },
  emits: ['skipTo'],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

const $timeInput = ref<HTMLInputElement | null>(null);
const $timeProgress = ref<HTMLProgressElement | null>(null);
const $progressTooltip = ref<HTMLElement | null>(null);

const tooltip = ref<string>('00:00');

const formatTime = (timeInSeconds: number): { minutes: string, seconds: string } => {
  const result = new Date(timeInSeconds * 1000).toISOString().slice(11, 19);

  return {
    minutes: result.slice(3, 5),
    seconds: result.slice(6),
  };
};

const updateTooltip = (event: any): void => {
  const skipTo = Math.round(
    (event.offsetX / event.target.clientWidth)
    * parseInt(event.target.getAttribute('max'), 10)
  );

  const time = formatTime(skipTo);
  tooltip.value = `${time.minutes}:${time.seconds}`;

  if ($timeProgress.value && $progressTooltip.value) {
    const rect = $timeProgress.value.getBoundingClientRect();
    $progressTooltip.value.style.left = `${event.pageX - rect.left}px`;
  }
};

const skipTo = (event: any) => {
  const skip = event.target.value;

  if ($timeInput.value && $timeProgress.value) {
    $timeInput.value.value = skip;
    $timeProgress.value.value = skip;
  }

  emits('skipTo', skip);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${cssClass}__progress`)
  }, [
    _createElementVNode("progress", {
      ref_key: "$timeProgress",
      ref: $timeProgress,
      class: _normalizeClass(`${cssClass}__progress-bar`),
      value: _ctx.progress,
      max: _ctx.duration,
      "aria-label": "Прогресс видео"
    }, null, 10, _hoisted_1),
    _createElementVNode("input", {
      ref_key: "$timeInput",
      ref: $timeInput,
      class: _normalizeClass(`${cssClass}__time-input`),
      value: _ctx.progress,
      max: _ctx.duration,
      min: "0",
      step: "1",
      type: "range",
      "aria-label": "Перемотать видео",
      onMousemove: updateTooltip,
      onInput: skipTo
    }, null, 42, _hoisted_2),
    _createElementVNode("span", {
      ref_key: "$progressTooltip",
      ref: $progressTooltip,
      class: _normalizeClass([
        `${cssClass}__time-input-tooltip`,
        `${cssClass}__tooltip`,
      ])
    }, _toDisplayString(tooltip.value), 3)
  ], 2))
}
}

})